import styled from "styled-components"

const BPSTabsStyled = styled.div`

    .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #0478c2;
        font-family: 'Mulish', sans-serif !important;
    }

    .ant-tabs .ant-tabs-ink-bar {
        background-color: #0478c2;
    }

    .ant-tabs .ant-tabs-tab-btn {
        font-family: 'Mulish', sans-serif !important;

    }

    .ant-tabs .ant-tabs-tab:hover {
        color: #0478c2;
    }
`

export { BPSTabsStyled }
